import { render, staticRenderFns } from "./storeStatistic.vue?vue&type=template&id=48d3ba04&scoped=true"
import script from "./storeStatistic.vue?vue&type=script&lang=js"
export * from "./storeStatistic.vue?vue&type=script&lang=js"
import style0 from "./storeStatistic.vue?vue&type=style&index=0&id=48d3ba04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d3ba04",
  null
  
)

export default component.exports